import { defineMessages, MessageDescriptor } from "react-intl";

import {
  RESERVED_SLOT_TAKEN_CODE,
  SAVED_ADDRESS_LIMIT_CODE,
  SavedAddressErrorCode,
} from "@app/util/savedLocations/savedAddressErrors";

const messages = defineMessages({
  geocodeNotFound: {
    id: "savedLocations.geocodeNotFound",
    defaultMessage: "We couldn't find that address. Please check it and try again.",
    description: "Warning when an address being saved as a saved location can't be geocoded",
  },
  geocodeUnavailable: {
    id: "savedLocations.geocodeUnavailable",
    defaultMessage: "We can't locate that address right now. Please try again later.",
    description:
      "Warning when an address being saved as a saved location can't be geocoded because geocoding is over its limit or unavailable",
  },
  limitReached: {
    id: "savedLocations.validationError.v1211",
    defaultMessage: "You've reached your saved locations limit. Delete one to save another.",
    description: "Error when the rep already holds the maximum number of saved locations",
  },
  reservedSlotTaken: {
    id: "savedLocations.validationError.v1212",
    defaultMessage: "Your Home or Work was just changed on another device. Please try again.",
    description: "Error when the rep's Home or Work was set elsewhere since the list loaded",
  },
});

export const savedAddressErrorMessages: Readonly<Record<SavedAddressErrorCode, MessageDescriptor>> =
  {
    [RESERVED_SLOT_TAKEN_CODE]: messages.reservedSlotTaken,
    [SAVED_ADDRESS_LIMIT_CODE]: messages.limitReached,
  };

export default messages;
